import {
  Flex, Title, Button
} from '@huspy/briks-web';
import { AMPLITUDE_FEATURE_FLAGS } from '@modules/core/api/types';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { useNavigate } from '@tanstack/react-router';
import { globalStyles } from '@shared/global.css';
import { useTranslation } from 'react-i18next';
import usePersistUser from '@modules/core/hooks/usePersistUser';
import { USER_ROLE } from '@modules/identity/api/const';
import CreditsTopSection from '@modules/core/presentation/v2/pages/Credits/features/TopSection';
import TransactionsList from '@modules/core/presentation/v2/pages/Credits/features/TransactionsTable';
import { CreditsInfoRoute } from '@modules/core/presentation/v2/routes';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import { useEffect } from 'react';
import useCredits from '@modules/core/hooks/useCredits';

const CreditsPage = () => {
  const { t } = useTranslation();

  const { user } = usePersistUser();
  const navigate = useNavigate();

  const { data: creditsData } = useCredits();

  const { featureFlags } = useFeatureFlags();

  const isUserManager = user?.roles?.includes(USER_ROLE.manager);

  const CLIENT_HUB_CREDITS_MODULE = featureFlags?.[AMPLITUDE_FEATURE_FLAGS.CLIENT_HUB_CREDITS_MODULE];

  useEffect(() => {
    if (CLIENT_HUB_CREDITS_MODULE) {
      trackAmplitudeEvent(USER_EVENTS.CREDITS.VIEWED);
    }
  }, [CLIENT_HUB_CREDITS_MODULE]);

  if (!CLIENT_HUB_CREDITS_MODULE) {
    return <></>;
  }

  return (
    <Flex direction='column' bg='white'>
      <Flex className={ globalStyles.largeMainShellMaxWidth } justify='space-between' align='center'>
        <Title fontSize='5xl' weight='medium' letterSpacing='-2'>{t('core.credits.title')}</Title>

        <Flex gap={ 4 }>
          <Button
            size='md'
            variant='secondary'
            onClick={ () => navigate({ to: CreditsInfoRoute.to }) }
          >
            {t('core.credits.learnMore')}
          </Button>
        </Flex>
      </Flex>

      <Flex className={ globalStyles.largeMainShellMaxWidth } direction='column'>
        <Flex paddingTop={ 6 } direction='column'>
          <CreditsTopSection
            availableCredits={ creditsData?.availableCredits }
            isGetMoreCreditsAvailable={ isUserManager }
          />
          {isUserManager ? (
            <Flex paddingTop={ 8 }>
              <TransactionsList />
            </Flex>
          ) : null}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CreditsPage;
